// @flow
import { get } from "lodash";
import type { Actions } from "@tvg/shared-actions/BetActions";
import type { BetTicketState } from "@tvg/types/Bet";

export type State = {
  config: BetTicketState,
  repeatBetNumber: ?number,
  showRepeatBet: boolean
};

export const initialState = {
  config: {
    isProcessing: false,
    isBetPlaced: false,
    isBettingError: false,
    errorBetMessage: "",
    betConfirmationTitle: "",
    repeatBetNumber: 1,
    randomTalentPhrase: "",
    randomTalentPhraseId: -1,
    hasFeedback: false,
    feedbackType: "error",
    partialFailure: false,
    partialInfo: "",
    partialInfoDetails: "",
    feedbackTitle: "",
    feedbackMsg: ""
  },
  repeatBetNumber: 1,
  showRepeatBet: false
};

export default function reducer(
  state: State = initialState,
  action: Actions
): State {
  switch (action.type) {
    case "SET_BET_TICKET_STATE": {
      return {
        ...state,
        config: { ...state.config, ...action.payload }
      };
    }
    case "SET_BET_REPEAT_NUMBER": {
      return {
        ...state,
        repeatBetNumber: get(action, "payload")
      };
    }
    case "SET_SHOW_REPEAT_BET": {
      return {
        ...state,
        showRepeatBet: action.payload
      };
    }
    default: {
      return state;
    }
  }
}
